import React from 'react';
import { PaymentFailedInstructionsProps } from '../types/Payment';
import { useTranslations } from '../../localization/useTranslations';

const PaymentFailedInstructions: React.FC<PaymentFailedInstructionsProps> = ({ retry_url, vs }) => {
  const translations = useTranslations();

  return (
    <>
      <div className="section section--information">
        <h4 className="section__title">{translations?.paymentFailedInstructions?.paymentFailedTitle || 'What now?'}</h4>
        <div className="section__wrapper">
          <div className="section__box">
            <div className="section__content">
              <h5 className="section__subtitle">
                {translations?.paymentFailedInstructions?.paymentFailedRetrySubtitle || 'Try to pay again'}
              </h5>
              <div className="section__description basic-14">
                <div
                  dangerouslySetInnerHTML={{
                    __html: window?.forbes_my_account_payments?.retryPaymentDescription,
                  }}
                />
              </div>
              {retry_url && (
                <div className="h-pt--20">
                  <a href={retry_url} className="button button--medium button--primary">
                    {translations?.paymentFailedInstructions?.retryPayment || 'Retry payment'}
                  </a>
                </div>
              )}
            </div>
          </div>

          <div className="section__box">
            <div className="section__content" style={{ marginBottom: 0 }}>
              <h5 className="section__subtitle">
                {translations?.paymentFailedInstructions?.paymentFailedOtherHelpSubtitle || "If you still can't"}
              </h5>
              <div className="section__description basic-14">
                <div
                  dangerouslySetInnerHTML={{
                    __html: window?.forbes_my_account_payments?.otherHelpDescription,
                  }}
                />{' '}
                <span className="h-color--text-primary">({vs})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentFailedInstructions;
